<yc-modal [formGroup]="formGroup"
  [modalHeader]="modalHeader"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="close()">

  <div [innerHtml]="modalContent | escapeHtml"></div>

  <!-- Checkbox to Dismiss -->
  <div class="mt-3">
    <yc-checkbox
      name="dismissHelp"
      [optionLabel]="'common:textDoNotShowThisHelpAgain2' | ycI18n: 'Do not show this message again. This content can be viewed in our Help Center at any time by clicking on the Help icon in the navigation.'">
    </yc-checkbox>
  </div>
</yc-modal>